import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";
import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from 'react-compare-slider';


import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";


import div2k_0006_color_ori_canny from "./results/edge/div2k_0006_color_ori_canny.png";
import div2k_0006_color_ori_ori from "./results/edge/div2k_0006_color_ori_ori.png";
import div2k_0006_color_ori_out from "./results/edge/div2k_0006_color_ori_out.png";
import div2k_0006_color_ori_prewitt from "./results/edge/div2k_0006_color_ori_prewitt.png";
import div2k_0006_color_ori_sobel from "./results/edge/div2k_0006_color_ori_sobel.png";

import div2k_0005_blur_1_box from "./results/blur/div2k_0005_blur_1_box.png";
import div2k_0005_blur_1_gaussian from "./results/blur/div2k_0005_blur_1_gaussian.png";
import div2k_0005_blur_1_ori from "./results/blur/div2k_0005_blur_1_ori.png";
import div2k_0005_blur_1_out from "./results/blur/div2k_0005_blur_1_out.png";

import D8QFibRVUAANxfU from "./results/deblur/D8QFibRVUAANxfU.png";
import newtest_D8QFibRVUAANxfU_cnn from "./results/deblur/newtest_D8QFibRVUAANxfU_cnn.png";
import newtest_D8QFibRVUAANxfU_color_blur_ori from "./results/deblur/newtest_D8QFibRVUAANxfU_color_blur_ori.png";
import newtest_D8QFibRVUAANxfU_color_blur_out from "./results/deblur/newtest_D8QFibRVUAANxfU_color_blur_out.png";
import newtest_D8QFibRVUAANxfU_color_blur_wiener from "./results/deblur/newtest_D8QFibRVUAANxfU_color_blur_wiener.png";

import div2k_0122_color_noise_3c_new_mpr from "./results/denoise/div2k_0122_color_noise_3c_new_mpr.png";
import div2k_0122_color_noise_3c_new_mean from "./results/denoise/div2k_0122_color_noise_3c_new_mean.png";
import div2k_0122_color_noise_3c_new_ori from "./results/denoise/div2k_0122_color_noise_3c_new_ori.png";
import div2k_0122_color_noise_3c_new_out from "./results/denoise/div2k_0122_color_noise_3c_new_out.png";
import div2k_0122_color_noise_3c_new_gt from "./results/denoise/div2k_0122_color_noise_3c_new_gt.png";

import div2k_0009_color_hole_15_gt from "./results/inpainting/0009.png";
import div2k_0009_color_hole_15_meanFilter from "./results/inpainting/div2k_0009_color_hole_15_meanFilter.png";
import div2k_0009_color_hole_15_medianFilter from "./results/inpainting/div2k_0009_color_hole_15_medianFilter.png";
import div2k_0009_color_hole_15_ori from "./results/inpainting/div2k_0009_color_hole_15_ori.png";
import div2k_0009_color_hole_15_out from "./results/inpainting/div2k_0009_color_hole_15_out.png";
import inpainting_rand from "./results/inpainting/inpainting_rand.png";

import div2k_0064_color_inpainting_text_gt from "./results/inpainting/0064.png";
import div2k_0064_color_inpainting_text_meanFilter from "./results/inpainting/div2k_0064_color_inpainting_text_meanFilter.png";
import div2k_0064_color_inpainting_text_medianFilter from "./results/inpainting/div2k_0064_color_inpainting_text_medianFilter.png";
import div2k_0064_color_inpainting_text_ori from "./results/inpainting/div2k_0064_color_inpainting_text_ori.png";
import div2k_0064_color_inpainting_text_out from "./results/inpainting/div2k_0064_color_inpainting_text_out.png";
import inpainting from "./results/inpainting/inpainting.png";



const Slider = ({img1, img2}) => (
    <div>
        <ReactCompareSlider
        itemOne={<ReactCompareSliderImage src={img1} />}
        itemTwo={<ReactCompareSliderImage src={img2} />}
        handle={<ReactCompareSliderHandle buttonStyle={{border: 0, backdropFilter: 'none', WebkitBackdropFilter: 'none', boxShadow: 'none'}} linesStyle={{ opacity: 0.5 }}/>}
        />
    </div>
)

const ImageResults = () => (
  <div>
    <Header as="h3" textAlign="center">
        Edge Detection
    </Header>
    <Grid columns={4}>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <p> Canny </p>
        </Grid.Column>
        <Grid.Column>
          <p> Prewitt </p>
        </Grid.Column>
        <Grid.Column>
          <p> Sobel </p>
        </Grid.Column>
        <Grid.Column>
          <p> <b> INSP-Net </b> </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <Slider img1={div2k_0006_color_ori_ori} img2={div2k_0006_color_ori_canny}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0006_color_ori_ori} img2={div2k_0006_color_ori_prewitt}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0006_color_ori_ori} img2={div2k_0006_color_ori_sobel}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0006_color_ori_ori} img2={div2k_0006_color_ori_out}/> 
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Header as="h3" textAlign="center">
        Image Denoising
    </Header>
    <Grid columns={4}>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <p> Mean Filter </p>
        </Grid.Column>
        <Grid.Column>
          <p> MPRNet </p>
        </Grid.Column>
        <Grid.Column>
          <p> <b> INSP-Net </b> </p>
        </Grid.Column>
        <Grid.Column>
          <p> Target Image </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <Slider img1={div2k_0122_color_noise_3c_new_ori} img2={div2k_0122_color_noise_3c_new_mean}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0122_color_noise_3c_new_ori} img2={div2k_0122_color_noise_3c_new_mpr}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0122_color_noise_3c_new_ori} img2={div2k_0122_color_noise_3c_new_out}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0122_color_noise_3c_new_ori} img2={div2k_0122_color_noise_3c_new_gt}/> 
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Header as="h3" textAlign="center">
        Image Inpainting
    </Header>
    <Grid columns={5}>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <p> Mean Filter </p>
        </Grid.Column>
        <Grid.Column>
          <p> Median Filter </p>
        </Grid.Column>
        <Grid.Column>
          <p> LaMa </p>
        </Grid.Column>
        <Grid.Column>
          <p> <b> INSP-Net </b> </p>
        </Grid.Column>
        <Grid.Column>
          <p> Target Image </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <Slider img1={div2k_0009_color_hole_15_ori} img2={div2k_0009_color_hole_15_meanFilter}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0009_color_hole_15_ori} img2={div2k_0009_color_hole_15_medianFilter}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0009_color_hole_15_ori} img2={inpainting_rand}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0009_color_hole_15_ori} img2={div2k_0009_color_hole_15_out}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0009_color_hole_15_ori} img2={div2k_0009_color_hole_15_gt}/> 
        </Grid.Column>
      </Grid.Row>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <Slider img1={div2k_0064_color_inpainting_text_ori} img2={div2k_0064_color_inpainting_text_meanFilter}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0064_color_inpainting_text_ori} img2={div2k_0064_color_inpainting_text_medianFilter}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0064_color_inpainting_text_ori} img2={inpainting}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0064_color_inpainting_text_ori} img2={div2k_0064_color_inpainting_text_out}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0064_color_inpainting_text_ori} img2={div2k_0064_color_inpainting_text_gt}/> 
        </Grid.Column>
      </Grid.Row>
    </Grid>

    <Header as="h3" textAlign="center">
        Image Blurring
      </Header>
    <Grid columns={3}>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <p> Box Filter </p>
        </Grid.Column>
        <Grid.Column>
          <p> Gaussian Filter </p>
        </Grid.Column>
        <Grid.Column>
          <p> <b> INSP-Net </b> </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <Slider img1={div2k_0005_blur_1_ori} img2={div2k_0005_blur_1_box}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0005_blur_1_ori} img2={div2k_0005_blur_1_gaussian}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={div2k_0005_blur_1_ori} img2={div2k_0005_blur_1_out}/> 
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Header as="h3" textAlign="center">
        Image Deblurring
    </Header>
    <Grid columns={4}>
      <Grid.Row 
textAlign="center">
        <Grid.Column>
          <p> Wiener Filter </p>
        </Grid.Column>
        <Grid.Column>
          <p> MPRNet </p>
        </Grid.Column>
        <Grid.Column>
          <p> <b> INSP-Net </b> </p>
        </Grid.Column>
        <Grid.Column>
          <p> Target Image </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row 
textAlign="center">

        <Grid.Column>
          <Slider img1={newtest_D8QFibRVUAANxfU_color_blur_ori} img2={newtest_D8QFibRVUAANxfU_color_blur_wiener}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={newtest_D8QFibRVUAANxfU_color_blur_ori} img2={newtest_D8QFibRVUAANxfU_cnn}/>
        </Grid.Column>
        <Grid.Column>
          <Slider img1={newtest_D8QFibRVUAANxfU_color_blur_ori} img2={newtest_D8QFibRVUAANxfU_color_blur_out}/> 
        </Grid.Column>
        <Grid.Column>
          <Slider img1={newtest_D8QFibRVUAANxfU_color_blur_ori} img2={D8QFibRVUAANxfU}/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

export default ImageResults;
